import React from "react";
import { any } from "prop-types";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import ListItem from "@mui/material/ListItem";
import IconButton from "@mui/material/IconButton";
import pdfLogo from "../../../assets/svg/pdf-logo.svg";
import "../SelectedFileList/selectedFileList.scss";

// const checkChecked = (checked, value) => {
//   const currentIndex = checked.findIndex((item) => item.id === value.id);
//   if (currentIndex === -1) {
//     return false;
//   } else {
//     return true;
//   }
// };

const CheckboxTitle = ({ checked, value, onClick, selectAllChecked }) => {
  return (
    <ListItem disablePadding>
      <ListItemButton role={undefined} onClick={onClick(value)} dense>
        <ListItemIcon>
          <Checkbox
            size="small"
            checked={checked.findIndex((item) => item.id === value.id) !== -1}
            tabIndex={-1}
          />
        </ListItemIcon>
        <IconButton>
          <img className="checkboxTitleIcon" src={pdfLogo} alt="Pdf Icon" />
        </IconButton>
        <ListItemText
          className="checkboxTitleIcon-title"
          size="small"
          primary={value.name}
        />
      </ListItemButton>
    </ListItem>
  );
};

CheckboxTitle.propTypes = {
  checked: any,
  value: any,
  onClick: any,
};

export default CheckboxTitle;
